<template>
	<div class="publicUserList">
		<v-content>
			<v-container fluid>
              <center><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="publicLoaded == false" /></center>
              <v-flex xs4>
                <div class="relative">
<!--                  <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>-->
                  <v-text-field style="margin-bottom: 10px;"  v-if="publicLoaded == true" label="Search" solo single-line v-model="search"></v-text-field>
<!--                  <v-text-field ref="searchField" append-icon="search" style="display: block; float:left;margin-right:0px;" id="quoteSearch" :value="search" solo single-line></v-text-field>-->
                  <v-btn v-if="publicLoaded"  class="public_user_position dashGenerateRep qtGenerate" @click="fncFilterUsers()" style="background: #333 !important; color: #fff !important;height: 30px;position: absolute !important; top: auto;     margin-top: -48px;display: block; right: 2px;">SEARCH</v-btn>
                  <v-btn v-if="publicLoaded"   class="public_user_position dashGenerateRep qtGenerate" @click="fncClearSearch()" style="background: #333 !important; color: #fff !important;height: 30px;position: absolute !important; top: auto; margin-top: -48px; display: block; right: 72px;">CLEAR</v-btn>
                  <!--<v-text-field @input="fncFilterUsers" v-if="publicLoaded == true && search != ''" label="Search" solo single-line v-model="search"></v-text-field>
                  <v-text-field append-icon="search" @input="fncFilterUsers" v-if="publicLoaded == true && search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />-->
                </div>
              </v-flex>
        <v-pagination
          v-model="page"
          :length=this.publicTotalPages
          :total-visible="7"
        ></v-pagination>
				<v-data-table :headers="headers" v-if="publicLoaded == true" id="hello" :items="filteredUsers" class="elevation-1" hide-actions disable-initial-sort :rows-per-page-items="[2000,40,60,80,100]">
					<template slot="items" slot-scope="props">
                      <tr>
                        <td width="45%" >{{ props.item.name }} {{ props.item.surname }}</td>
                        <td width="20%" >{{ props.item.contactnum }}</td>
                        <td width="20%" >{{ props.item.email }}</td>
                        <td width="10%">
                          <v-menu offset-y>
                            <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                            <v-list>
                              <v-list-tile @click.prevent="fncEditPricelist(props.item.id)">
                                <v-list-tile-title>
                                  <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link User Pricelists</a>
                                </v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile @click.prevent="fncEditPassword(props.item.id, props.item.email)">
                                <v-list-tile-title>
                                  <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Update Password</a>
                                </v-list-tile-title>
                              </v-list-tile>
                              <!--<v-list-tile @click.prevent="fncEditStatus(props.item.id)">
                                <v-list-tile-title>
                                  <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Statuses</a>
                                </v-list-tile-title>
                              </v-list-tile>-->
                              <!--<v-list-tile @click.prevent="fncViewUser(props.item.id, props.item.region)">
                                <v-list-tile-title>
                                  <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Details</a>
                                </v-list-tile-title>
                              </v-list-tile>-->

                            </v-list>
                          </v-menu>
                        </td>
                        <td width="5%"  v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditUser(props.item)"><i class="material-icons">edit</i></a></td>
                        <!--<td width="5%"  v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'user')"><i class="material-icons">delete_forever</i></a></td>-->
                      </tr>
                    </template>
				</v-data-table>
			</v-container>
		</v-content>
		<!--<modal></modal>-->
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
    name: 'UserList',
    intRoleEdit: 0,
    data() {
      return {
        search: '',
        filteredUsers: [],
        headers: [
          { text: 'Full Name', value: 'name', width: '45%' },
          { text: 'Contact No', value: 'registration_no', width: '20%' },
          { text: 'Email Address', value: 'email', width: '20%' },
          { text: 'User Actions', value: 'actions', width: '10%' },
          { text: 'Edit', value: 'edit', width: '5%' },
          /*{ text: 'Delete', value: 'delete', width: '5%' }*/
        ],
        getPage: 1,
        totalPages: 1,
        page: 1,
      }
    },
    methods: {

      fncClearSearch() {
        this.search = '';
        this.fncFilterUsers();
      },
      fncFilterUsers() {
        this.$store.dispatch({
          type: 'fncPopulateUsers',
          context: 4,
          page: this.page,
          search: this.search
        });
      },
      fncDeleteUser(userId, type) {
        var deleteUser = confirm('Are you sure you want to delete this user?');
        if (deleteUser === true) {
          this.$store.dispatch({
            type: 'fncDeleteUser',
            userId: userId,
            context: 4,
            deleteType: type
          })
        }
      },
      fncEditNotifications(userId) {
        this.$store.dispatch({
          type: 'fncSetUserNotifications',
          userId: userId,
          context: 4
        })
      },
      fncEditPassword(userId, userEmail) {
        var updatePassword = confirm('Are you sure you want to update the users password?');
        if (updatePassword === true) {
          this.$store.dispatch({
            type: 'fncUpdateUserPassword',
            userId: userId,
            userEmail: userEmail
          })
        }
      },
      fncEditPricelist(userId) {
        this.$store.dispatch({
          type: 'fncEditUserPricelist',
          userId: userId
        })
      },
      fncEditStatus(userId) {
        this.$store.dispatch({
          type: 'fncEditStatus',
          userId: userId,
          status: 'quote'

        })
      },
      fncEditUser(user) {
        this.$store.dispatch('fncSetEditUserPublic', user);
        /*this.$store.dispatch('fncPopulateUserRegions');
        this.$store.dispatch('fncSetupUserCreate', '');*/
      },
      fncViewUser(userId, regions) {
        this.$store.dispatch({
          type: 'fncViewUser',
          userId: userId,
          regions: regions
        })
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'publicUsers',
        'publicUserSearch',
        'publicLoaded',
        'publicTotalPages'
      ])
    },
    beforeMount() {
      this.$store.dispatch({
        type: 'fncPopulateUsers',
        context: 4,
        page: this.page,
        search: this.search
      });
    },
    watch: {
      publicUsers() {
        this.filteredUsers = this.publicUsers;
      },
      publicUserSearch() {
        if (this.search == '') {
          this.filteredUsers = this.publicUsers;
        } else {
          this.filteredUsers = this.publicUserSearch;
        }
      },
      page() {
        this.$store.dispatch({
          type: 'fncPopulateUsers',
          context: 4,
          page: this.page,
          search: this.search
        });
      }
    }

  }
</script>

<style scoped>
  @import '../../shared/assets/css/shared.css'
</style>
